import { BrowserRouter } from 'react-router-dom'

import AppWrapper from './components/AppWrapper'
import GameContextProvider from './context/GameContext'
import PageRoutes from './routes'
import { useEffect } from 'react'
import { AudioProvider } from './context/AudioContext'

function App() {
  // 防止右鍵點擊跟長按點擊
  useEffect(() => {
    const handleContextmenu = (e: MouseEvent) => {
      e.preventDefault()
    }
    document.addEventListener('contextmenu', handleContextmenu)
    return function cleanup() {
      document.removeEventListener('contextmenu', handleContextmenu)
    }
  }, [])
  return (
    <BrowserRouter>
      <GameContextProvider>
        <AudioProvider>
          <AppWrapper>
            <PageRoutes />
          </AppWrapper>
        </AudioProvider>
      </GameContextProvider>
    </BrowserRouter>
  )
}

export default App
